type SortableSymbolLibraryAsset = {
  id: string;
  label: string;
};

/** Assets intentionally pinned ahead of the ordinary natural-label order. */
const PINNED_SYMBOL_LIBRARY_ASSET_IDS = [
  "FLOOR_PLAN/SYMBOLS & SIGNS/Bonnie",
] as const;

export function compareSymbolLibraryAssets(
  a: SortableSymbolLibraryAsset,
  b: SortableSymbolLibraryAsset,
): number {
  const aPinnedIndex = PINNED_SYMBOL_LIBRARY_ASSET_IDS.indexOf(
    a.id as (typeof PINNED_SYMBOL_LIBRARY_ASSET_IDS)[number],
  );
  const bPinnedIndex = PINNED_SYMBOL_LIBRARY_ASSET_IDS.indexOf(
    b.id as (typeof PINNED_SYMBOL_LIBRARY_ASSET_IDS)[number],
  );

  if (aPinnedIndex !== -1 || bPinnedIndex !== -1) {
    if (aPinnedIndex === -1) return 1;
    if (bPinnedIndex === -1) return -1;
    return aPinnedIndex - bPinnedIndex;
  }

  return a.label.localeCompare(b.label, undefined, { numeric: true });
}
